/**
 * @description 导出默认网路配置
 **/
const networkSetting: NetworkConfig = {
  // 最长请求时间
  requestTimeout: 10000,
  // 操作正常code，支持String、Array、Number多种类型
  successCode: [ 200, 0, '0' ]
}
export default networkSetting
